import { useCallback } from "react";
import { useConfigurationContext } from "../root/ConfigurationContext";
import {
  dealPipelines as defaults,
  getDealPipeline as findPipeline,
} from "./pipelines";
export function useDealPipelines() {
  const config = useConfigurationContext();
  const dealPipelines = config.dealPipelines?.length
    ? config.dealPipelines
    : defaults;
  const getDealPipeline = useCallback(
    (value?: string) => findPipeline(value, dealPipelines),
    [dealPipelines],
  );
  return {
    dealPipelines,
    defaultDealPipeline: dealPipelines[0],
    getDealPipeline,
  };
}
